import Modal from 'modal-vanilla'

export default {
  init() {
    const showHistory = document.querySelectorAll('.show-history')
    const modalTitle = document.querySelector('.modal-title')
    const modalBody = document.querySelector('.modal-body')

    showHistory.forEach((element) => {
      element.addEventListener('click', (event) => {
        modalTitle.innerHTML = element.dataset.title
        modalBody.innerHTML = element.dataset.content
        event.preventDefault()
        new Modal({
          el: document.getElementById('history'),
        }).show()
      })
    })
  },
  finalize() {},
}
